if (!customElements.get('po-radio-selector-size')) {
  class PoRadioSelectorSize extends HTMLElement {
    constructor() {
      super();
      this.fieldset = this.querySelector('fieldset');
      this.confirmButton = this.querySelector('.js-size-picker-confirm-btn');
      this.variantsData = JSON.parse(this.querySelector('[data-variants-measurements-script]').textContent);
      this.measurementsElement = this.querySelectorAll('[data-clip-on-size-guide-field]');      

      this.sizeModalSpan = document.querySelectorAll('[data-sizecontent]');
    }

    connectedCallback() {
      if (this.fieldset && this.confirmButton) {
        // By changing the selected input, 
        // update the button with the data needed to publish the event 'optionValueSelectionChange'
        // Also update the measurements shown below.
        this.fieldset.addEventListener('change', (event) => {
          const targetDataOptionValueId = event.target.dataset.optionValueId;
          const targetDataOptionValue = event.target.value;
          
          if (targetDataOptionValueId != undefined && targetDataOptionValue != undefined) {
            this.confirmButton.setAttribute('data-option-value-id', targetDataOptionValueId);
            this.confirmButton.setAttribute('data-value', targetDataOptionValue);
          }

          this.handleUpdateMeasurements(targetDataOptionValue);
        });

        // When the button is clicked, 
        // the event 'optionValueSelectionChange' is published 
        // and the button text is updated which opens the modal.
        this.confirmButton.addEventListener('click', (event) => {
          const target = event.currentTarget;
          
          publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
            data: {
              event,
              target,
              selectedOptionValues: this.selectedOptionValues,
            },
          });

          this.updateSizeModalContent(this.confirmButton.dataset.value);
        });
      }
    }

    get selectedOptionValues() {
      return Array.of(this.confirmButton).filter(Boolean).map(({ dataset }) => dataset.optionValueId);
    }

    // Update the text of the button that opens the modal
    updateSizeModalContent(newContent) {
      if (this.sizeModalSpan.length > 0 ) {
        this.sizeModalSpan.forEach((span) => {
          span.innerText = newContent;
        });
      }
    }

    // Update measure elements with the new measurements based on the pre-selected option value
    handleUpdateMeasurements(targetDataOptionValue) {
      const measurements = this.variantsData[targetDataOptionValue];
      if (measurements) {
        this.measurementsElement.forEach(element => {
          const field = element.dataset.clipOnSizeGuideField;
          const value = measurements[field];

          if (typeof value !== 'undefined') {
              element.textContent = value;
          }
        });
      }
    }
  }
  

  customElements.define("po-radio-selector-size", PoRadioSelectorSize);
}